<template>
  <div class="passo3">
    <div class="container wp-box section section-artigo with-box">
      <h2>Soluções para você</h2>

      <div class="timeline">
        <div id="timeline-wrap">
          <div id="timeline"></div>
          <div class="marker mfirst timeline-icon one active">1</div>
          <div class="marker m2 timeline-icon two active">2</div>
          <div class="marker m3 timeline-icon three active">3</div>
          <div class="marker m4 timeline-icon four">4</div>
          <div class="marker m5 timeline-icon five">5</div>
          <div class="marker mlast timeline-icon six">6</div>
        </div>
      </div>
    </div>

    <div class="container wp-box section section-artigo with-box">
      <div class="row">
        <div class="colsm-12">
          <p>Agora, conta pra gente qual a sua profissão:</p>
        </div>
      </div>
      

      <div class="row" v-if="profissoes">
        <div class="colsm-6">
          <div class="control-item">
            <ul>
              <li v-for="(obj, index) in profissoes" :key="index">
                <input type="radio" name="profissao" class="font-icon" :id="'prof-'+obj.iID_Profissao" :value="obj.iID_Profissao" v-model="dados.iID_Profissao" />
                <label :for="'prof-'+obj.iID_Profissao" class="opcao-radio">{{obj.vProfissao}}</label>
              </li>
              <small class="form-text text-muted" v-show="error">Selecione uma opção.</small>
            </ul>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="colsm-8">
          <small class="form-text text-muted" v-if="erroApi">Erro de comunicação com o servidor. Tente novamente mais tarde.</small>
        </div>
      </div>

      <div class="row">
        <div class="colsm-8">
          <a class="btn blue" @click="validarAvancar(dados)">Próxima Etapa</a> <span class="etapa-anterior">ou <router-link :to="{name: 'passo-dois', params: {dados}}" >volte à etapa anterior</router-link></span>
        </div>
      </div>

    </div>
  </div>
</template>

<script>

import axios from 'axios';

export default {
  name: "passo3",
  data: function() {
    return {
      dados: {
        
      },
      erroApi: false,
      profissoes: null,
      error: null,
      urlApi: process.env.VUE_APP_URL_API
    };
  },
  methods: {
    validarAvancar(dados) {

      var _this = this;

      

      if(!_this.dados.iID_Profissao){
        _this.error = true;
      } else {
        _this.dados.iPasso_Simulador = 3;
        this.$loading(true);
          axios.post(_this.urlApi + 'Visita_Dados_PF/' + _this.dados.iID_Visita, _this.dados)
            .then(function (response) {
              try{
                dataLayer.push({
                  'passoSimulador': 'Passo3',
                  'profissao': _this.profissoes.find(x => x.iID_Profissao === _this.dados.iID_Profissao).vProfissao,
                  'event': 'proximoPasso',
                  'tipo': 'PF'
                });
              } catch(error){
                console.error(error);
              }

              _this.$router.push({name:'passo-quatro', params:{dados}});

              _this.$loading(false);
            })
            .catch(function (error) {
              _this.erroApi = true;
              _this.$loading(false);
            });
      }

    }
  },
  created: function (){
    var _this = this;
    _this.$loading(true)
    _this.dados = this.$route.params.dados;
    axios
      .get(_this.urlApi + 'Profissoes')
      .then(response => {
        
          _this.profissoes = response.data;
          _this.$loading(false);
        }
      )
      .catch(error => {
        
        _this.$loading(false);
      })

  },
  props: {}
};
</script>